import { useEffect, useState } from 'react';
import { Stack, Group } from './layout';
import { Text, Badge, Button } from './core';
import { Card } from './data-display';
import { Switch } from './inputs';
import {
  getPushLocalState,
  requestNotificationPermission,
  enablePushLocally,
  disablePushLocally,
  setPushSoundEnabled,
  setPushVibrationEnabled,
  setPushShowPreview,
  initPushSystem,
  PushPermissionState,
} from '../../utils/push';

export function PushSettings() {
  const [state, setState] = useState(getPushLocalState());

  useEffect(() => {
    initPushSystem();
  }, []);

  const refresh = () => setState(getPushLocalState());

  const handleToggleRegistered = async (value: boolean) => {
    if (value) {
      const permission = await requestNotificationPermission();
      if (permission === 'granted') {
        enablePushLocally();
      }
    } else {
      disablePushLocally();
    }
    refresh();
  };

  const statusColor = (permission: PushPermissionState) => {
    if (permission === 'granted') return 'green';
    if (permission === 'denied') return 'red';
    return 'gray';
  };

  return (
    <Card padding="md" withBorder>
      <Stack gap="sm">
        <Group justify="space-between" align="center">
          <Text fw={600}>Push Notifications</Text>
          <Badge color={statusColor(state.pushPermission)}>{state.pushPermission}</Badge>
        </Group>

        <Switch
          label="Push Notifications"
          checked={state.pushRegistered}
          onChange={(e) => handleToggleRegistered(e.currentTarget.checked)}
        />
        <Switch
          label="Sound"
          checked={state.pushSoundEnabled}
          onChange={(e) => {
            setPushSoundEnabled(e.currentTarget.checked);
            refresh();
          }}
        />
        <Switch
          label="Vibration"
          checked={state.pushVibrationEnabled}
          onChange={(e) => {
            setPushVibrationEnabled(e.currentTarget.checked);
            refresh();
          }}
        />
        <Switch
          label="Show Preview"
          checked={state.pushShowPreview}
          onChange={(e) => {
            setPushShowPreview(e.currentTarget.checked);
            refresh();
          }}
        />

        <Group justify="space-between">
          <Text size="sm" c="dimmed">
            Device ID: {state.pushDeviceId || 'Not set'}
          </Text>
          <Button variant="light" size="xs" onClick={() => refresh()}>
            Refresh
          </Button>
        </Group>
      </Stack>
    </Card>
  );
}

export default PushSettings;
